<template>
    <div>
        <div class="col-md-12 text-center">
            <el-empty description="Page Not Found" style="margin-top:10%;">
                <h2 style="margin-top:-10px;">404</h2><br>
                <el-button type="primary" @click="goBack">Go Back</el-button>
            </el-empty>
        </div> 
    </div>
</template>

<script>
  export default {
    methods: {
      goBack() {
        this.$router.go(-1)
      }
    }
  }
</script>